import { graphql } from "@/graphql/generated/gql";

export const createDownloadLinkMutationDocument = graphql(/* GraphQL */ `
  mutation createDownloadLink($input: DownloadLinkCreateInput!) {
    createDownloadLink(downloadLinkCreateInput: $input) {
      id
    }
  }
`);

export const createSignedUploadUrlMutationDocument = graphql(/* GraphQL */ `
  mutation createSignedUploadUrlMutation($input: SignedUploadUrlCreateInput!) {
    createSignedUploadUrl(signedUploadUrlCreateInput: $input) {
      permaUrl
      signedUrl
      type
    }
  }
`);

export const makeFileAccessibleToPublicMutationDocument = graphql(/* GraphQL */ `
  mutation makeFileAccessibleToPublic($input: MakeFileAccessibleToPublicInput!) {
    makeFileAccessibleToPublic(makeFileAccessibleToPublicInput: $input)
  }
`);
